import React from "react";
import { Route, Switch } from "react-router-dom";
import { Theme, useMediaQuery } from "@material-ui/core";

import ImageViewer from "../components/ImageViewer";

// routes
import PrivateRoutes from "./PrivateRoutes";
import PublicRoutes from "./PublicRoutes";
import AuthRoutes from "modules/auth/routes/AuthRoutes";
import LegacyRoutes from "modules/legacy/routes";

import { coreRoutesConstants } from "./routesConstants";
import { authRoutesConstants } from "modules/auth/routes/routesConstants";

import PrivateRoute from "./PrivateRoute";
import SmallScreenPage from "../pages/SmallScreen";

const RootRoutes: React.FC = () => {
  const isSmallScreenUp = useMediaQuery(
    (theme: Theme) => theme.breakpoints.up("sm"),
    {
      defaultMatches: true
    }
  );

  if (!isSmallScreenUp) {
    return <SmallScreenPage />;
  }

  return (
    <>
      <Switch>
        <PrivateRoute path={coreRoutesConstants.app.path}>
          <PrivateRoutes />
        </PrivateRoute>

        <Route path={coreRoutesConstants.public.path}>
          <PublicRoutes />
        </Route>

        <Route path={authRoutesConstants.root.path}>
          <AuthRoutes />
        </Route>

        <Route>
          <LegacyRoutes />
        </Route>
      </Switch>

      <ImageViewer />
    </>
  );
};

export default RootRoutes;
